// extracted by mini-css-extract-plugin
export default {"home":"desktop_home__lC8g-","hero":"desktop_hero__YZf0C"};